import React, { useState, useEffect, useRef } from 'react'
import clsx from 'clsx'
import { HeaderUserMenu } from '../../../partials'
import { useLayout } from '../../core'
import { HeaderActivityLog } from './HeaderActivityLog'
import { useAuth } from '../../../../app/modules/auth'

// Fallback user icon
const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
)

const itemClass = 'ms-1 ms-xl-2'

const Navbar = () => {
  const { config } = useLayout()
  const { currentUser } = useAuth()
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const userMenuTimerRef = useRef<any>(null)

  // RBAC: Ikon Activity Log hanya tampil jika role pengguna mengizinkan modul 'activity_log' (atau Admin/SuperAdmin)
  const roleName = currentUser?.role?.name?.toUpperCase()
  const allowedMenus = (currentUser?.role?.allowedMenus || '').split(',').map((m: string) => m.trim().toLowerCase())
  const canViewActivityLog =
    roleName === 'ADMIN' ||
    roleName === 'SUPERADMIN' ||
    allowedMenus.includes('activity_log')

  const handleUserMenuMouseEnter = () => {
    if (userMenuTimerRef.current) clearTimeout(userMenuTimerRef.current)
    window.dispatchEvent(new CustomEvent('ccs-close-header-dropdowns', { detail: 'userMenu' }))
    setIsUserMenuOpen(true)
  }

  const handleUserMenuMouseLeave = () => {
    if (userMenuTimerRef.current) clearTimeout(userMenuTimerRef.current)
    userMenuTimerRef.current = setTimeout(() => {
      setIsUserMenuOpen(false)
    }, 300)
  }

  useEffect(() => {
    const handleCloseDropdowns = (e: any) => {
      if (e?.detail !== 'userMenu') {
        setIsUserMenuOpen(false)
      }
    }
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (!target.closest('.ccs-user-avatar-wrapper')) {
        setIsUserMenuOpen(false)
      }
    }
    window.addEventListener('ccs-close-header-dropdowns', handleCloseDropdowns)
    document.addEventListener('click', handleClickOutside)
    return () => {
      window.removeEventListener('ccs-close-header-dropdowns', handleCloseDropdowns)
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <div className='app-navbar flex-shrink-1 min-w-0 ccs-app-navbar-container d-flex align-items-center gap-1 gap-sm-2'>
      
      {/* ACTIVITY LOG NOTIFICATIONS (IMAGE 2) - Only visible for ADMIN and CLIENT */}
      {canViewActivityLog && (
        <div className={clsx('app-navbar-item', itemClass)}>
          <HeaderActivityLog variant='navbar' />
        </div>
      )}

      {/* USER MENU (AVATAR) - SMOOTH HOVER & CLICK WITHOUT REFRESH */}
      <div
        className={clsx('app-navbar-item me-0 position-relative ccs-user-avatar-wrapper', itemClass)}
        onMouseEnter={handleUserMenuMouseEnter}
        onMouseLeave={handleUserMenuMouseLeave}
      >
        <div
          className='cursor-pointer ccs-header-avatar-btn'
          onClick={() => {
            window.dispatchEvent(new CustomEvent('ccs-close-header-dropdowns', { detail: 'userMenu' }))
            setIsUserMenuOpen(v => !v)
          }}
          title='Menu Profil'
        >
          <div className='ccs-user-avatar-styled d-flex align-items-center justify-content-center'>
            <UserIcon />
            <span className='ccs-avatar-online-dot' title='Status: Active'></span>
          </div>
        </div>

        {isUserMenuOpen && (
          <div
            onMouseEnter={handleUserMenuMouseEnter}
            onMouseLeave={handleUserMenuMouseLeave}
          >
            <HeaderUserMenu />
          </div>
        )}
      </div>

    </div>
  )
}

export { Navbar }
